// Themse, change filname: [blank], -coy, -dark, -funky, -okaidia, -solarizedlight, -tomorrow, -twilight
require("prismjs/themes/prism-okaidia.css");
require("./src/styles/copy-button.css");

exports.onClientEntry = () => {
  // Initialize theme
  const savedTheme = localStorage.getItem('theme');
  
  if (savedTheme) {
    document.documentElement.setAttribute('data-theme', savedTheme);
  } else {
    // If no saved theme, check OS preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const theme = prefersDark ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', theme);
  }

  window.gatsbyRemarkCopyToClipboard = (button) => {
    const codeBlock = button.parentElement.nextElementSibling;
        
    if (codeBlock && codeBlock.className === 'gatsby-highlight') {
      const code = codeBlock.innerText;
      
      navigator.clipboard.writeText(code).then(() => {
        button.textContent = 'Copied!';
        
        setTimeout(() => {
          button.textContent = 'Copy';
        }, 2000);
      });
    }
  };
  
    document.addEventListener('keydown', (event) => {
      if ((event.key === 'Enter' || event.key === ' ') && event.target.classList.contains('gatsby-remark-prismjs-copy-button')) {
          event.preventDefault();
          window.gatsbyRemarkCopyToClipboard(event.target);
      }
    });
  };

// Make code blocks keyboard accessible
exports.onRouteUpdate = () => {
  const codeBlocks = document.querySelectorAll('pre[class*="language-"]');
  codeBlocks.forEach((block) => {
    // Add tabindex to make focusable
    block.setAttribute('tabindex', '0');
    
    // Add role and aria-label for scrollable regions
    block.setAttribute('role', 'region');
    block.setAttribute('aria-label', 'Code block');
  });
};